import React, { useState } from "react";
import Swal from "sweetalert2";
import { successMsg } from "../SuccessHandler";
import EntryColor from "../container/EntryColor";
import EntryMoreModal from "../modals/EntryMoreModal";
import StatisticsModal from "../modals/StatisticsModal";
import { MDBTooltip } from "mdb-react-ui-kit";
import ErrorCodes from "../../constants/ErrorCodes";
import { useUpdateFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";
import { isDisabled } from "@testing-library/user-event/dist/utils";

const EntriesTable = ({
  entries,
  setEntries,
  userInfo,
  setSessionNoLongerExists,
  resultsList,
  raceInfo,
  isDisabled,
}) => {
  const [entryInfo, setEntryInfo] = useState({
    EntryNum: "",
    EntryName: "",
    TrainerName: "",
    OwnerName: "",
    Breeders: "",
    Pedigrees: "",
    inputSelect: "",
    ML: "",
    Weight: "",
    SaddleNum: "",
    CoupleChar: "",
    RiderName: "", //Jockie
    EarlyScr: false,
    FinishPos: 0,
  });
  const [entryStatisticsInfo, setEntryStatisticsInfo] = useState([]);
  const [changeEntries, setChangeEntries] = useState(false);
  const { updateEntriesInfo } = useUpdateFunctions();

  const entriesTableChangeHandler = (e) => {
    const x = [...entries];
    let name = e.target.name;
    let key = e.target.getAttribute("data-key");
    let value = e.target.value;
    if (value === "") {
      value = " ";
    }
    x[key][name] = value;
    x[key]["Change"] = true;

    setEntries(x);
    setChangeEntries(true);
  };

  //Onchange Modal EntryMore
  const entryModalChangeHandler = (e) => {
    setEntryInfo({
      ...entryInfo,
      [e.target.name]: e.target.value,
      LastModUsername: localStorage.getItem("userName"),
      Change: true,
    });

    const x = [...entries];
    let name = e.target.name;
    let key = e.target.getAttribute("data-key");
    let value = e.target.value;
    if (value === "") {
      value = " ";
    }
    x[key][name] = value;
    x[key]["Change"] = true;

    setEntries(x);
    setChangeEntries(true);
  };

  //Botón Guardar Entries (Editar)
  const handleSaveEntries = (entries) => {
    if (changeEntries) {
      ConfirmDialog(`Changes will be saved!`).then(async (result) => {
        if (result.isConfirmed) {
          let InParams = [];
          entries.forEach((element) => {
            if (element.Change) {
              InParams.push({
                ...element,
                EntryNum: parseInt(element.EntryNum),
                Weight: parseInt(element.Weight, 10),
                ML: parseFloat(element.ML),
              });
            }
          });

          if (InParams.length === 0) {
            InParams = {};
          }

          const res = await updateEntriesInfo(
            { EntryList: InParams },
            userInfo.LogonSessionID,
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }
            return;
          } else {
            successMsg("Save Entry");
            setChangeEntries(false);
          }
        }
      });
    } else {
      Swal.fire("No changes in the Entries to update");
    }
  };

  //Función para los Scratch
  const changeScratch = (entryID, scr) => {
    let localState = [...entries];
    localState.forEach((item, i) => {
      if (item.EntryID === entryID) {
        if (item.FinishPos === -1) {
          localState[i].FinishPos = 0;
        } else {
          localState[i].FinishPos = -1;
        }
        localState[i].EarlyScratch = scr;
        localState[i].Change = true;
      }
    });
    setEntries(localState);
    setChangeEntries(true);
  };

  //RadioButton PTF
  const ptfOnChange = (event, entryID) => {
    const newItems = [...entries];

    let idPTF = event.target.id;
    newItems.forEach((entry, i) => {
      if (entry.EntryID === parseInt(idPTF)) {
        newItems[i].IsPTF = true;
      } else {
        newItems[i].IsPTF = false;
      }
      if (entry.EntryID === entryID) {
        newItems[i].Change = true;
      }
    });

    setEntries(newItems);
    setChangeEntries(true);
  };

  //Modal para el botón More i, data
  const showModalEntryMore = (i, data) => {
    data.inputSelect = i;
    setEntryInfo({ ...data });
  };

  //Información de los Statistics
  const showModalStatistics = (data) => {
    setEntryStatisticsInfo(data);
  };

  let tableContent = [];
  if (entries) {
    tableContent = entries.map((data, i) => {
      let className = "";
      let disabledScr = false;
      let img = "";
      if (resultsList.WPSList) {
        resultsList.WPSList.forEach((item, i) => {
          if (item.Pos === 1) {
            if (item.Entrynum === data.EntryNum) {
              className = "classGolden";
              disabledScr = true;
              img = "images/goldCup.png";
            }
          }

          if (item.Pos === 2) {
            if (item.Entrynum === data.EntryNum) {
              className = "classSilver";
              disabledScr = true;
              img = "images/silverCup.png";
            }
          }

          if (item.Pos === 3) {
            if (item.Entrynum === data.EntryNum) {
              className = "classBronze";
              disabledScr = true;
              img = "images/bronzeCup.png";
            }
          }
        });
      }

      let statistics,
        Weight = "";

      //Validación de derechos (entries.statisticsEntryRight)
      if (true) {
        statistics = (
          <td>
            <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Statistics">
              <button
                type="button"
                className="btn btn-info m-0 mt-1"
                data-toggle="modal"
                data-target="#entryStatisticsModal"
                data-placement="top"
                onClick={() => showModalStatistics(data)}
              >
                <span>
                  <i className="fas fa-chart-line fa-bold"></i>
                </span>
              </button>
            </MDBTooltip>
          </td>
        );
      }
      //Validación de derechos (entries.statisticsEntryRight)
      if (true) {
        statistics = (
          <td>
            <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Statistics">
              <button
                type="button"
                className="btn btn-info m-0 mt-1 btn-sm"
                data-toggle="modal"
                data-target="#entryStatisticsModal"
                data-placement="top"
                title="Statistics"
                onClick={() => showModalStatistics(data)}
              >
                <span>
                  <i className="fas fa-chart-line fa-bold"></i>
                </span>
              </button>
            </MDBTooltip>
          </td>
        );
      }

      if (data.Weight !== 0) {
        Weight = data.Weight;
      }

      let buttonScr = "";
      if (data.FinishPos === -1) {
        if (data.EarlyScratch) {
          buttonScr = (
            <div className="btn-group mt-1" disabled={isDisabled}>
              <button
                type="button"
                className="btn btn-success btn-sm"
                id={"btnScrach" + data.EntryID}
                onClick={(e) => {
                  changeScratch(data.EntryID, false);
                }}
                disabled={isDisabled}
              >
                E
              </button>
              <button
                type="button"
                className="btn btn-light btn-sm"
                disabled={isDisabled}
              >
                L
              </button>
            </div>
          );
          <tr key={data.EntryID}>
            <td className="d-none">{data.EntryID}</td>
            <td>
              <span>
                <img src={img} alt="" className="mt-1" />
              </span>
            </td>
            <td key={"saddle" + data.EntryID}>
              <EntryColor
                entryNum={data.EntryNum}
                saddleNum={data.SaddleNum}
                finishPos={data.FinishPos}
              />
            </td>
            <td>
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="EntryName"
                  data-key={i}
                  value={data.EntryName}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    textAlign: "center",
                  }}
                  disabled
                />
              </del>
            </td>
            <td>
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="RiderName"
                  data-key={i}
                  value={data.RiderName}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    textAlign: "center",
                  }}
                  disabled
                />
              </del>
            </td>
            <td>
              <div className="btn-group mt-1">{buttonScr}</div>
            </td>
            <td
              style={{
                width: "47px",
              }}
            >
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="Weight"
                  data-key={i}
                  value={Weight}
                  style={{ backgroundColor: "transparent", border: "none" }}
                  disabled
                />
              </del>
            </td>
            <td style={{ textAlign: "center" }}>
              <del>
                <div className="custom-control custom-radio mt-1">
                  <input
                    type="radio"
                    id={data.EntryID}
                    name="customRadio"
                    className="custom-control-input"
                    onClick={(e) => ptfOnChange(e, data.EntryID)}
                    checked={data.IsPTF}
                    disabled={isDisabled}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor={data.EntryID}
                  ></label>
                </div>
              </del>
            </td>
            <td>
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="More">
                <button
                  type="button"
                  className="btn btn-info m-0 mt-1 btn-sm btnMore"
                  data-placement="top"
                  disabled
                  data-toggle="modal"
                  data-target="#entryMoreModal"
                  onClick={() => showModalEntryMore(i, data)}
                >
                  <span>
                    <i className="fas fa-plus fa-bold"></i>
                  </span>
                </button>
              </MDBTooltip>
            </td>
            {statistics}
          </tr>;
        } else {
          buttonScr = (
            <div className="btn-group mt-1">
              <button
                type="button"
                className="btn btn-light btn-sm"
                disabled={isDisabled}
              >
                E
              </button>
              <button
                type="button"
                className="btn btn-success btn-sm"
                id={"btnScrach" + data.EntryID}
                onClick={(e) => {
                  changeScratch(data.EntryID, true);
                }}
                disabled={isDisabled}
              >
                L
              </button>
            </div>
          );
        }
        return (
          <tr key={data.EntryID} className={className}>
            <td className="d-none">{data.EntryID}</td>
            <td>
              <span>
                <img src={img} alt="" className="mt-1" />
              </span>
            </td>
            <td>
              <EntryColor
                entryNum={data.EntryNum}
                saddleNum={data.SaddleNum}
                finishPos={data.FinishPos}
              />
            </td>
            <td>
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="EntryName"
                  data-key={i}
                  value={data.EntryName}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    textAlign: "center",
                  }}
                  disabled
                  onChange={entriesTableChangeHandler}
                />
              </del>
            </td>
            <td>
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="RiderName"
                  data-key={i}
                  value={data.RiderName}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    textAlign: "center",
                  }}
                  disabled
                  onChange={entriesTableChangeHandler}
                />
              </del>
            </td>
            <td>{buttonScr}</td>
            <td
              style={{
                width: "47px",
              }}
            >
              <del>
                <input
                  className="form-control"
                  type="text"
                  name="Weight"
                  data-key={i}
                  value={Weight}
                  style={{
                    width: "47px",
                    backgroundColor: "transparent",
                    border: "none",
                  }}
                  disabled
                  onChange={entriesTableChangeHandler}
                />
              </del>
            </td>
            <td style={{ textAlign: "center" }}>
              <del>
                <div className="custom-control custom-radio mt-1">
                  <input
                    type="radio"
                    id={data.EntryID}
                    name="customRadio"
                    className="custom-control-input"
                    disabled
                    onClick={(e) => ptfOnChange(e, data.EntryID)}
                    checked={data.IsPTF}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor={data.EntryID}
                  ></label>
                </div>
              </del>
            </td>
            <td>
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="More">
                <button
                  type="button"
                  className="btn btn-info m-0 mt-1 btn-sm btnMore"
                  data-placement="top"
                  data-toggle="modal"
                  data-target="#entryMoreModal"
                  onClick={() => showModalEntryMore(i, data)}
                >
                  <span>
                    <i className="fas fa-plus fa-bold"></i>
                  </span>
                </button>
              </MDBTooltip>
            </td>
            {statistics}
          </tr>
        );
      } else {
        return (
          <tr key={data.EntryID} className={className}>
            <td className="d-none">{data.EntryID}</td>
            <td>
              <span>
                <img src={img} alt="" className="mt-1" />
              </span>
            </td>
            <td>
              <EntryColor
                entryNum={data.EntryNum}
                saddleNum={data.SaddleNum}
                finishPos={data.FinishPos}
                style={{ display: "inline-block" }}
              />
            </td>
            <td>
              <input
                className="form-control"
                type="text"
                name="EntryName"
                data-key={i}
                value={data.EntryName}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "center",
                }}
                onChange={entriesTableChangeHandler}
                maxLength={50}
              />
            </td>
            <td>
              <input
                className="form-control"
                type="text"
                name="RiderName"
                data-key={i}
                value={data.RiderName}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "center",
                }}
                onChange={entriesTableChangeHandler}
                maxLength={50}
              />
            </td>
            <td>
              <div className="btn-group mt-1">
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  id={"btnScrach" + data.EntryID}
                  onClick={(e) => {
                    changeScratch(data.EntryID, true);
                  }}
                  disabled={disabledScr || isDisabled}
                >
                  E
                </button>
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  id={"btnScrach" + data.EntryID}
                  onClick={(e) => {
                    changeScratch(data.EntryID, false);
                  }}
                  disabled={disabledScr || isDisabled}
                >
                  L
                </button>
              </div>
            </td>
            <td
              style={{
                width: "47px",
              }}
            >
              <input
                className="form-control"
                type="text"
                name="Weight"
                data-key={i}
                value={Weight}
                style={{
                  width: "47px",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onChange={entriesTableChangeHandler}
              />
            </td>
            <td style={{ textAlign: "center" }}>
              <del>
                <div className="custom-control custom-radio mt-1">
                  <input
                    type="radio"
                    id={data.EntryID}
                    name="customRadio"
                    className="custom-control-input"
                    onClick={(e) => ptfOnChange(e, data.EntryID)}
                    checked={data.IsPTF}
                    disabled={isDisabled}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor={data.EntryID}
                  ></label>
                </div>
              </del>
            </td>
            <td>
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="More">
                <button
                  type="button"
                  className="btn btn-info m-0 btn-sm mt-1 btnMore"
                  data-placement="top"
                  data-toggle="modal"
                  data-target="#entryMoreModal"
                  onClick={() => showModalEntryMore(i, data)}
                >
                  <span>
                    <i className="fas fa-plus fa-bold"></i>
                  </span>
                </button>
              </MDBTooltip>
            </td>
            {statistics}
          </tr>
        );
      }
    });
  }

  let table = (
    <table
      className={
        raceInfo && raceInfo.RaceStatus === "C"
          ? "table"
          : "table table-striped"
      }
      id="entriesT"
    >
      <thead className="thead-dark">
        <tr className="text-center table-md header header-tbEntries">
          <th style={{ width: "45px" }}></th>
          <th>#</th>
          <th>Horse</th>
          <th>Jockey</th>
          <th>SCR</th>
          <th>W</th>
          <th>PTF</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody className="table-sm tbodyEntries">{tableContent}</tbody>
    </table>
  );

  //Limpiar Inputs al cerrar el Modal de More
  const CleanInputs = () => {
    setEntryInfo({
      EntryNum: "",
      EntryName: "",
      CoupleChar: "",
      SaddleNum: "",
      RiderName: "",
      ML: "",
      Weight: "",
      TrainerName: "",
      OwnerName: "",
    });
  };

  return (
    <>
      {entryInfo && (
        <EntryMoreModal
          onChange={entryModalChangeHandler}
          handleClick={handleSaveEntries}
          infoModal={entryInfo}
          CleanInputs={CleanInputs}
          isDisabled={isDisabled}
        />
      )}
      <StatisticsModal infoStatistics={entryStatisticsInfo} />
      <div className="col">
        <div className="mt-3">{table}</div>
        <div className="">
          <div className="mt-3">
            <div className="btn-toolbar justify-content-end">
              {!isDisabled && (
                <button
                  type="button"
                  className="btn btn-info mb-3"
                  onClick={() => handleSaveEntries(entries, false)}
                >
                  Save Entries
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EntriesTable;
